import React, { useState } from 'react'
import { User } from '../../context/AuthContext'

interface AvatarProps {
  user?: User
  size?: number
  className?: string
}

const Avatar: React.FC<AvatarProps> = ({ user, size = 32, className = '' }) => {
  // A photo that fails to load falls back to initials rather than a broken image.
  const [failedUrl, setFailedUrl] = useState<string | null>(null)

  const getInitials = (): string => {
    if (!user) return ''

    const firstInitial = user.firstName
      ? user.firstName.charAt(0).toUpperCase()
      : ''
    const lastInitial = user.lastName
      ? user.lastName.charAt(0).toUpperCase()
      : ''

    return `${firstInitial}${lastInitial}`
  }

  const initials = getInitials()
  const style = {
    width: `${size}px`,
    height: `${size}px`,
    fontSize: `${size / 2}px`,
  }
  const photoUrl =
    user?.photoUrl && user.photoUrl !== failedUrl ? user.photoUrl : null

  return (
    <div className={`avatar ${className}`} style={style}>
      {photoUrl ? (
        <img
          className="avatar__photo"
          src={photoUrl}
          alt={`${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim()}
          onError={() => setFailedUrl(photoUrl)}
        />
      ) : (
        <div className="avatar__initials">{initials}</div>
      )}
    </div>
  )
}

export default Avatar
